import { OrderFulfillmentContainerComponent } from '../order-fulfillment-container.component';
export { OrderFulfillmentAddressComponent } from './order-fulfillment-address/order-fulfillment-address.component';
export { OrderFulfillmentInswitchInhouseComponent } from './order-fulfillment-address/order-fulfillment-inswitch-inhouse/order-fulfillment-inswitch-inhouse.component';
export { OrderFulfillmentConfirmationComponent } from './order-fulfillment-confirmation/order-fulfillment-confirmation.component';
export { OrderFulfillmentCrossSellComponent } from './order-fulfillment-cross-sell/order-fulfillment-cross-sell.component';
import { OrderFulfillmentPaymentComponent } from './order-fulfillment-payment/order-fulfillment-payment.component';
import { OrderFulfillmentPersonalComponent } from './order-fulfillment-personal/order-fulfillment-personal.component';
import { OrderRedirectToMijnComponent } from './order-redirect-to-mijn/order-redirect-to-mijn.component';

export const orderFulfillmentComponents = [
  OrderFulfillmentContainerComponent,
  OrderFulfillmentPaymentComponent,
  OrderFulfillmentPersonalComponent,
  OrderRedirectToMijnComponent,
];
